module.exports = __webpack_public_path__ + "static/media/utm_avobold.205c0763.woff";


//////////////////
// WEBPACK FOOTER
// ./src/static/Assets/Fonts/utm_avobold.woff
// module id = 375
// module chunks = 7